import Vue from 'vue';

import AlertMessage from './../components/shared/AlertMessage.vue';
import Nav from './../components/shared/Nav.vue';
import Pagination from './../components/shared/Pagination.vue';
import Divider from './../components/shared/Divider.vue';
import PageScroller from './../components/shared/PageScroller.vue';

// used in the whole system
Vue.mixin({
  data() {
    return {
      errorMessage: '',
      showError: false,
      successMessage: '',
      showSuccess: false,
    };
  },
  components: {
    'my-alert': AlertMessage,
    'my-nav': Nav,
    'my-pagination': Pagination,
    Divider,
    PageScroller,
  },
});
